<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>设备转移</span>
          <el-button v-if="multipleSelection.length != 0" style="float: right;" type="primary"
            @click="openTransferDialog(multipleSelection)">转移
          </el-button>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="输入网关名称|网关编号|设备名字|设备编号搜索" v-model="search"
            @keyup.enter.native="searchBtn">
          </el-input>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"
            :class="search.length == 0 ? 'ccc' : 'blue'"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <div style="margin-top:15px;color:#999;margin-left:15px;">以下列表仅显示可转移设备</div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange" :span-method="mergeCell">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" width="170px">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="编号" width="170px"></el-table-column>
          <el-table-column prop="protocolName" label="网关协议">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="toModuleProtocolPage(scope.row.protocolId)">
                {{ scope.row.protocolName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="devName" label="设备名称">
            <template slot-scope="scope">
              {{scope.row.devName?scope.row.devName:"--"}}
            </template>
          </el-table-column>
          <el-table-column prop="devCode" label="设备编号">
            <template slot-scope="scope">
              {{scope.row.devCode?scope.row.devCode:"--"}}
            </template>
          </el-table-column>
          <el-table-column prop="devDevProtocolName" label="设备协议">
            <template slot-scope="scope">
              {{scope.row.devDevProtocolName?scope.row.devDevProtocolName:"--"}}
            </template>
          </el-table-column>
          <el-table-column prop="account" label="所属账号" width="170px">
            <template slot-scope="scope">
              {{scope.row.account}}{{ '('+scope.row.createName+')' }}
            </template>
          </el-table-column>
          <el-table-column prop="protocolName" label="操作" width="70">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="openTransferDialog([scope.row])">转移</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="设备转移" :visible.sync="maskVisible" width="70%" :close-on-click-modal="false">
      <span style="color:red;">此操作将实现选中的设备及网关转移至带接收账号下且不可逆，请谨慎操作。</span>
      <div style="padding-top:15px">
        <span style="color:#999;">待转移设备列表：</span>
        <el-table ref="multipleTable" :data="transferData" style="width: 100%" :span-method="mergeCell">
          <el-table-column label="序号" width="55">
            <template slot-scope="scope">
              {{ scope.row.index }}
            </template>
          </el-table-column>
          <el-table-column label="名称" width="160px">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="编号" width="160px"></el-table-column>
          <el-table-column prop="protocolName" label="网关协议">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="toModuleProtocolPage(scope.row.protocolId)">
                {{ scope.row.protocolName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="devName" label="设备名称">
            <template slot-scope="scope">
              {{scope.row.devName?scope.row.devName:"--"}}
            </template>
          </el-table-column>
          <el-table-column prop="devCode" label="设备编号">
            <template slot-scope="scope">
              {{scope.row.devCode?scope.row.devCode:"--"}}
            </template>
          </el-table-column>
          <el-table-column prop="devDevProtocolName" width="160px" label="设备协议">
            <template slot-scope="scope">
              {{scope.row.devDevProtocolName?scope.row.devDevProtocolName:"--"}}
            </template>
          </el-table-column>
          <el-table-column prop="account" label="所属账号" width="140px">
            <template slot-scope="scope">
              {{scope.row.account}}{{ '('+scope.row.createName+')' }}
            </template>
          </el-table-column>
        </el-table>
        <div style="color:#999;margin:25px 0px 10px">待接收账号信息：</div>
        <el-form :inline="true" ref="transferUser" :model="transferUser" class="demo-form-inline">
          <el-form-item label="账号" prop="account" :rules="[{ required: true, message: '待接收用户账号不能为空' }]">
            <el-input v-model="transferUser.account" placeholder="请输入待接收用户账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" :rules="[{ required: true, message: '待接收账号密码不能为空' }]">
            <el-input type="password" v-model="transferUser.password" placeholder="请输入待账号密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="maskVisible = false">取 消</el-button>
        <el-button type="primary" @click="transfer">转 移</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {

      return {
        commuType: sessionStorage.getItem('commuType'),
        maskVisible: false,
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "", //搜索
        tableData: [],//表格数据
        multipleSelection: [],//选中的条目
        transferData: [],//准备进行转移的条目
        transferUser: {//待接收账号认证信息
          account: '',
          password: ''
        },
      };
    },
    computed: {
      tokenData: function () {
        return {
          access_token: this.$cookies.get('access_token'),
          commuType: this.commuType
        }
      }
    },
    created() { },
    methods: {
      toModuleProtocolPage(id) {
        if (!id) return;
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: id
          }
        });
      },
      //获取列表
      getpageList() {
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          search: this.search, //搜索栏
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.transferableDevicePage(para)
          .then(res => {
            if (res.code == 1) {
              var data = res.data.resultPage
              this.tableData = this.dataHandle(data);
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //合并单元格
      mergeCell({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < 4 || columnIndex > 6) {
          var mergeRow = row.deviceList.length
          if (mergeRow > 0) {//开始合并的行
            if (row.isFirst) {
              return {
                rowspan: mergeRow,
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 0
              };
            }
          } else {
            return {
              rowspan: 1,
              colspan: 1
            };
          }
        }
      },
      //跳转到详情页
      detailBtn(id) {
        //  直接调用$router.push 实现携带参数的跳转
        this.$router.push({
          path: "/device/moduleDetail",
          query: {
            id: id
          }
        });
      },
      //搜索功能
      searchBtn() {
        this.currentPage = 1
        this.getpageList();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.currentPage = 1
        this.getpageList();
      },
      //选择的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      openTransferDialog(data) {
        this.transferData = this.dataHandle(JSON.parse(JSON.stringify(data)))
        this.maskVisible = true
        this.$nextTick(() => {
          this.$refs.transferUser.resetFields();//等弹窗里的form表单的dom渲染完再去除验证
        });
      },
      //转移
      transfer() {
        this.$refs.transferUser.validate(valid => {
          if (valid) {
            this.$confirm('此操作为不可逆操作, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let mduIds = []
              let devIds = []
              this.transferData.forEach(element => {
                mduIds.indexOf(element.id) == -1 ? mduIds.push(element.id) : ""
                element.devId ? devIds.push(element.devId) : ""
              });
              let para = {
                mduIds: mduIds.join(','),
                devIds: devIds.join(','),
                account: this.transferUser.account,
                password: this.transferUser.password
              }
              API.transferDev(para).then(res => {
                if (res.code == 1) {
                  this.$message.success('转移成功');
                  this.maskVisible = false
                  this.getpageList();
                } else {
                  this.$message.error('转移失败：' + res.msg);
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
          }
        })
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.getpageList();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList();
      },
      dataHandle(data) {
        var resData = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].deviceList.length > 0) {
            //有关联设备
            for (let j = 0; j < data[i].deviceList.length; j++) {
              var json = JSON.parse(JSON.stringify(data[i]))
              json.devId = data[i].deviceList[j].id
              json.devName = data[i].deviceList[j].name
              json.devCode = data[i].deviceList[j].code
              json.devDevProtocolName = data[i].deviceList[j].devProtocolName
              json.isFirst = j == 0
              json.index = i + 1
              resData.push(json)
            }
          } else {
            //无关联设备
            data[i].isFirst = false
            data[i].index = i + 1
            resData.push(data[i])
          }
        }
        return resData;
      }
    },
    mounted() {
      this.getpageList();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/deviceTransfer.vue